module.exports = __webpack_public_path__ + "img/our_advantage2.ad876c87.png";